// Mock data for frontend development

export const testimonials = [
  {
    id: 1,
    name: "Familie Weber",
    location: "Dortmund-Hörde",
    text: "Schnell, zuverlässig und fair. Die Wohnung meiner Eltern wurde innerhalb eines Tages besenrein geräumt. Wertanrechnung war transparent und großzügig.",
    rating: 5
  },
  {
    id: 2,
    name: "M. Schmidt",
    location: "Dortmund-Innenstadt",
    text: "Sehr professionell und diskret. Trotz schwieriger Situation (Messi-Wohnung) wurde alles respektvoll und ohne Vorurteile erledigt. Absolute Empfehlung!",
    rating: 5
  },
  {
    id: 3,
    name: "Hausverwaltung Richter",
    location: "Dortmund-Aplerbeck",
    text: "Zuverlässiger Partner für Nachlassauflösungen. Festpreise, pünktliche Termine, saubere Übergabe. Arbeiten regelmäßig mit Schössow zusammen.",
    rating: 5
  }
];

export const services = [
  {
    id: 1,
    title: "Haushaltsauflösung",
    slug: "haushaltsaufloesung-dortmund",
    description: "Komplette Auflösung von Haushalten in Dortmund – vom Einfamilienhaus bis zur Eigentumswohnung. Besenrein, Festpreis, Wertanrechnung.",
    icon: "Home"
  },
  {
    id: 2,
    title: "Wohnungsauflösung",
    slug: "wohnungsaufloesung-dortmund",
    description: "Schnelle und diskrete Wohnungsauflösung in ganz Dortmund. Ideal bei Umzug, Nachlass oder Trennung.",
    icon: "Building2"
  },
  {
    id: 3,
    title: "Messi-Wohnung Räumung",
    slug: "messie-wohnung-dortmund",
    description: "Sensible und professionelle Räumung von Messi-Wohnungen. Mit Schutzkleidung, Sortierung und fachgerechter Entsorgung.",
    icon: "PackageOpen"
  },
  {
    id: 4,
    title: "Keller & Dachboden",
    slug: "keller-dachboden-entruempelung-dortmund",
    description: "Entrümpelung von Kellern, Dachböden und Garagen. Auch bei schwierigen Zugangswegen oder großen Mengen.",
    icon: "Warehouse"
  },
  {
    id: 5,
    title: "Sperrmüll-Abtransport",
    slug: "sperrmuell-abtransport-dortmund",
    description: "Kurzfristiger Abtransport von Sperrmüll, Möbeln und Altgeräten. Entsorgung nach Vorschrift inklusive.",
    icon: "Trash2"
  },
  {
    id: 6,
    title: "Nachlassauflösung",
    slug: "nachlassaufloesung-dortmund",
    description: "Respektvolle Auflösung von Nachlässen in Dortmund. Mit Dokumentensicherung, Wertermittlung und Anrechnung.",
    icon: "FileText"
  }
];

export const faqData = [
  {
    question: "Was kostet eine Haushaltsauflösung in Dortmund?",
    answer: "Die Kosten hängen von Größe, Zugänglichkeit und Menge ab. Typische Spannen: 1-Zimmer 600–1.200 €, 2-Zimmer 900–1.800 €, Einfamilienhaus 1.800–4.500 €. Nach kurzer Abstimmung (auch per Foto/Video) erhalten Sie einen verbindlichen Festpreis. Wertanrechnung ist möglich."
  },
  {
    question: "Wie schnell sind Termine möglich?",
    answer: "In der Regel innerhalb weniger Tage, Express-Termine nach Absprache. Wir arbeiten Mo–Sa 08–20 Uhr und melden uns meist am selben Tag zurück."
  },
  {
    question: "Ist die Übergabe besenrein?",
    answer: "Ja, wir übergeben besenrein. Das bedeutet: grobe Reinigung, Kehrarbeiten und Räumung aller Gegenstände. Auf Wunsch übernehmen wir auch Demontagen und dokumentieren die Entsorgung."
  },
  {
    question: "Wie funktioniert die Wertanrechnung?",
    answer: "Verwertbare Gegenstände (Möbel, Elektrogeräte, Antiquitäten) werden geschätzt und transparent vom Gesamtpreis abgezogen. Sie erhalten eine detaillierte Aufstellung."
  },
  {
    question: "Wird sortenrein entsorgt?",
    answer: "Ja, wir trennen Abfälle nach Vorschrift: Restmüll, Sperrmüll, Elektroschrott, Papier, Metall etc. Entsorgungsnachweise stellen wir auf Wunsch aus."
  },
  {
    question: "Arbeiten Sie auch bei schwierigen Zugängen?",
    answer: "Ja, auch bei engen Treppenhäusern, fehlenden Aufzügen oder Altbauten in der Innenstadt. Wir kalkulieren entsprechend und setzen erfahrene Mitarbeiter ein."
  },
  {
    question: "Was ist bei einer Messi-Wohnung anders?",
    answer: "Wir arbeiten mit Schutzkleidung, sortieren besonders sorgfältig (Dokumente, Wertsachen) und entsorgen hygienisch. Diskretion ist selbstverständlich."
  },
  {
    question: "Können Schlüssel übergeben werden?",
    answer: "Ja, nach Absprache können Sie Schlüssel hinterlegen. Wir arbeiten auch ohne Ihre Anwesenheit und übergeben besenrein."
  },
  {
    question: "Entstehen Zusatzkosten?",
    answer: "Nein, der Festpreis nach Besichtigung/Fotos ist verbindlich. Zusatzleistungen (z.B. Renovierung, Sondermüll) werden vorher besprochen."
  },
  {
    question: "Wie läuft eine Nachlassauflösung ab?",
    answer: "Wir sichten gemeinsam mit Ihnen oder nach Anweisung, sichern Dokumente, ermitteln Werte und kümmern uns um die fachgerechte Entsorgung. Respekt und Diskretion sind garantiert."
  },
  {
    question: "Gibt es Entsorgungsnachweise?",
    answer: "Ja, auf Wunsch stellen wir Nachweise über die ordnungsgemäße Entsorgung aus – wichtig für Vermieter oder Behörden."
  },
  {
    question: "In welchen Stadtteilen arbeiten Sie?",
    answer: "Wir decken das gesamte Stadtgebiet Dortmund ab: alle 12 Stadtbezirke von Innenstadt über Hörde, Aplerbeck bis Mengede und Scharnhorst."
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Haushaltsauflösung: Checkliste & Zeitplan",
    slug: "haushaltsaufloesung-checkliste-zeitplan",
    excerpt: "Wann starten, was entsorgen, was behalten? Mit dieser Checkliste behalten Sie den Überblick bei der Haushaltsauflösung.",
    date: "2025-01-15",
    readTime: "6 min"
  },
  {
    id: 2,
    title: "Was kostet eine Wohnungsauflösung wirklich?",
    slug: "kosten-wohnungsaufloesung-preisfaktoren",
    excerpt: "Größe, Zugang, Sortieraufwand – welche Faktoren bestimmen den Preis? Ein transparenter Blick hinter die Kalkulation.",
    date: "2025-01-10",
    readTime: "7 min"
  },
  {
    id: 3,
    title: "Messi-Wohnung räumen: Vorgehen & Verantwortung",
    slug: "messie-wohnung-raeumen-vorgehen",
    excerpt: "Wer zahlt, wie läuft die Räumung ab und welche rechtlichen Aspekte gibt es? Antworten für Betroffene und Angehörige.",
    date: "2025-01-05",
    readTime: "8 min"
  }
];

export const stadtbezirke = [
  "Innenstadt-West",
  "Innenstadt-Nord",
  "Innenstadt-Ost",
  "Aplerbeck",
  "Brackel",
  "Eving",
  "Hörde",
  "Hombruch",
  "Huckarde",
  "Lütgendortmund",
  "Mengede",
  "Scharnhorst"
];